import { parseObjectArrayIdString } from "./utils";

export const getInactiveIncidentVariables = (user, perPage, page) => ({
  originatorId: user?.id,
  perPage,
  page,
  oriIds: parseObjectArrayIdString(user?.selectedOrisObjs),
});
